import React from 'react';
import clsx from 'clsx';
import { Radio, type RadioChangeEvent } from 'antd';
import { Gap } from '@common/components/gap';
import { CardCollapse } from '@common/components/card-collapse';
import { Colors } from 'works/legacy/lib/style-helper';

export type ComboRadioOption = {
  label: string;
  value?: string;
  disabled?: boolean;
  open?: boolean;
  content?: React.ReactNode;
};

type Props = {
  options?: ComboRadioOption[];
  disabled?: boolean;
  name?: string;
  value?: ComboRadioOption['value'];
  onChange?: (e: RadioChangeEvent) => void;
};

export const ComboRadio = ({
  options = [],
  name,
  value,
  onChange,
  disabled,
}: Props) => (
  <>
    <Radio.Group
      name={name}
      value={value}
      disabled={disabled}
      onChange={onChange}
      className="wk-combo-radio"
    >
      <Gap vertical fullWidth size="md">
        {options.map((option) => (
          <label
            key={option.value}
            htmlFor={option.value}
            className="wk-combo-radio__label"
          >
            <CardCollapse
              className={clsx('wk-combo-radio__item', {
                'wk-combo-radio__item--selected': value === option.value,
              })}
              key={option.value}
              open={option.open || value === option.value}
              label={
                <Radio
                  id={option.value}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option.label}
                </Radio>
              }
            >
              {option.content}
            </CardCollapse>
          </label>
        ))}
      </Gap>
    </Radio.Group>
    <style jsx global>{`
      .wk-combo-radio {
        display: inline;
      }
      .wk-combo-radio .wk-combo-radio__label {
        display: block;
        width: 100%;
      }
      .wk-combo-radio .wk-combo-radio__label:hover {
        cursor: pointer;
      }
      .wk-combo-radio .wk-card-collapse {
        width: 100%;
      }
      .wk-combo-radio .wk-card-collapse .ant-card-body {
        padding: 24px;
      }
      .wk-combo-radio .wk-combo-radio__item--selected {
        border-color: ${Colors.elm};
      }
    `}</style>
  </>
);
